import { useCallback, useEffect, useState } from 'react'

import { Results } from '../../../types'
import { get } from '../../../utils/api'
import { handleApiErrors } from '../../../utils/apiErrors'

export type ProductClass = {
  id: number
  productClass: string
}

type ProductClassResults = Results<ProductClass>

const useFetchProductClasses = (productId: number) => {
  const [productClasses, setProductClasses] = useState<
    ProductClass[] | undefined
  >(undefined)
  const [isFetching, setFetching] = useState(false)

  const fetchProductClasses = useCallback(
    () =>
      get<ProductClassResults>(
        `/product_classes/?product=${productId}&limit=1000`
      )
        .then((data) => setProductClasses(data.results))
        .catch((err) => handleApiErrors(err))
        .finally(() => setFetching(false)),
    [productId]
  )

  useEffect(() => {
    setFetching(true)
    fetchProductClasses()
  }, [fetchProductClasses])

  return { productClasses, isFetching }
}

export default useFetchProductClasses
